module.exports = __webpack_public_path__ + "img/b-and-b-hotels-ktm.6e3302db.svg";